module.exports = __webpack_public_path__ + "img/Socialuj.92b187dd.svg";